<template>
  <div class='callSet'>
    <div class="explain">
        <img src="@/assets/img/equipment/topImg3.png" class="imgs">
        <!-- <div class="txt">管理其他家长<br><span>实现共同管理</span></div> -->
    </div>
    <p class="title">禁用时间段</p>
    <div class='list' v-for='(item,i) in list' :key='i'>
        <p class="tit flex-between">{{names[i]}}<van-switch v-model="item.status" inactive-color="#dcdee0" size="20px" /></p>
        <template v-if='item.status'>
          <p class=" flex-between"><span class='input' @click="getAdd(i,'startTime')">{{item.startTime||'--'}}</span> 至 <span class='input' @click="getAdd(i,'endTime')">{{item.endTime||'--'}}</span></p>
        </template>
        <template v-else>
          <p class="font16 gray">已禁用当前时间段</p>
        </template>
    </div>
    <div class="listWeek flex-between" @click="setWeek">
       <span class="tit">重复</span>
       <div class="gray flex-between">
         <span class=''>
             每周<template v-for='(obj,j) in week'><template v-if='j>0'>/</template>{{weeks[obj]}}</template>
        </span>
         <svg-icon icon-class="right"/> 
       </div>
    </div>
    <div class="btn"> 
        <div class="btn-primary" @click='submit'>保存</div>
    </div> 
   
  <!--添加-->
  <van-action-sheet v-model="isAdd" :lazy-render='false'>
        <van-datetime-picker ref="picker"
          v-model="currentTime"
          type="time"
          :title="title"
          :min-hour="minH" :min-minute='minM' :max-minute='maxM' @change='onChange'
          :max-hour="maxH" @confirm='confirm' @cancel='isAdd=false'
        />
  </van-action-sheet>

  <!--选择每天-->
    <van-action-sheet v-model="isShow">
      <div class="addCon">
         <p class="btn flex-between"><span @click="cancle">取消</span><b>重复</b><span class='sure' @click='getWeek'>确定</span></p>
         <div class="wayCon">
           <p :class="item.check?'check':''" v-for='(item,i) in weekList' :key='i' 
            @click='item.check=!item.check'>每周{{item.text}}
            <span><van-icon name="success" class="success"/></span></p>
         </div>
      </div>
    </van-action-sheet>
  </div>
</template>
<script>
import {getClassPatternByStudentId,updateClassPatternTime} from "@/api/api.equipment";
  export default {
    data() {
      return {
        list:'',
        isAdd:false,
        currentTime:'',
        minH:6,
        maxH:11,
        type:0,//0上午,1下午,2晚上,
        names:['上午','下午','晚上'],
        weeks:['日','一','二','三','四','五','六'],
        weekList:[],
        minM:0,
        maxM:59,
        currentTime:'',
        week:[],
        isShow:false,
        weekName:'',
      }
    },
   created(){
     this.weekList=[{text:'一',value:'1',check:false},{text:'二',value:'2',check:false},
                  {text:'三',value:'3',check:false},{text:'四',value:'4',check:false},{text:'五',value:'5',check:false}
                  ,{text:'六',value:'6',check:false},{text:'日',value:'0',check:false}];
     this.getList();
    },
    methods: {
      getAdd(i,name){
        this.currentTime='';
        let str=[{min:6,max:11},{min:12,max:17},{min:18,max:20}];
        this.isAdd=true;
        this.num=i;
        this.name=name;
        this.minH=str[i].min;
        this.maxH=str[i].max;
       this.$nextTick(()=>{
         this.currentTime=this.list[i][name];
       })
        if(name=='endTime'){
          this.title='结束时间';
        }else{
          this.title='开始时间';
        }
      },
      setWeek(){
         let week=this.week.join('');
         this.weekList.forEach(item=>{
              if(week.indexOf(item.value)>-1){
                item.check=true;
              }
          })
          this.isShow=true;
      },
      getWeek(){
        let arr=this.weekList.filter(item=>item.check);
        if(arr.length>0){
            this.week=arr.map(item=>item.value);
            this.cancle();
        }else{
          this.$toast('请选择内容');
        }
        
      },
      onChange() {
        let str=this.$refs.picker.getPicker().getValues();//获取当前选中数组值
        if(parseInt(str[0])==6){//当时=6，最小分>0
          this.minM=1;
        }else{
          this.minM=0;
        }
      },
      confirm(value){
        if(value=='06:00'){
          this.$toast('当前不能选择06：00点整');
          return false;
        }
        this.list[this.num][this.name]=value;
        this.isAdd=false;
      },
       getList(){
         getClassPatternByStudentId({
              studentId:this.loginUser.studentId
           }).then((data) => {
              if(data.result.list.length>0){
                data.result.list.forEach(item=>{
                  item.status=item.status==1?true:false;
                })
                 this.list=data.result.list;
                 this.week=data.result.week.split('');
                 let week=data.result.week,arr='';
                 this.weekList.forEach(item=>{
                    if(week.indexOf(item.value)>-1){
                      item.check=true;
                      arr+=item.text;
                    }
                })
                 
                 this.weekName=arr;
              }
              
           })
       },
       submit(){
         let arr=JSON.parse(JSON.stringify(this.list));
         let isCur=true;
         for(var i=0;i<3;i++){
           let str=arr[i];
           if(str.status){//启用
              str.status=1;
              if(str.startTime==''||str.endTime==''){
                this.$toast('请选择'+this.names[i]+'时间段');
                isCur=false;
                break;
              }
           }else{
                str.status=0;
                str.startTime='';
                str.endTime='';
           }
         }
         if(!isCur)return
         let params={
                  studentId:this.loginUser.studentId,
                  list:arr,
                  week:this.week.join('')
         };
         updateClassPatternTime(params).then((data) => {
                if (data && data.result) {
                     this.$toast('保存成功');
                     this.$router.go(-1);
                }
            })
         
       },
       cancle(){
         this.isShow=false;
         this.isAdd=false;
       },
    },
  }
</script>
<style lang="scss" >
.callSet{
   padding:0.12rem;
   position: relative;
   .explain{
      position: relative;
      .imgs{
          width: 100%;
        }
    }
    .title{
      font-size: .18rem;
      color: rgba(0,0,0,0.9);
      margin-top: .2rem;
      margin-bottom: .12rem;
    }
  .list{
    padding:0.12rem;
    font-size: .18rem;
    background: #fff;
    border-radius: 8px;
    margin-bottom: .12rem;
    .tit{
       display: flex;
       align-items: center;
       margin-bottom: .12rem;
    }
    .input{
      border:1px solid rgba(0,0,0,.2);
      border-radius: 4px;
      width:45%;
      max-width:2rem;
      text-indent: 20px;
      display: inline-block;
      vertical-align: middle;
      height: .4rem;
      line-height: .4rem;
      position: relative;
      background: url(../../../assets/img/equipment/clock.png) no-repeat 94% center #fff;
      background-size:.2rem;
    }
  }
  .listWeek{
    line-height: .48rem;
    padding:0rem .12rem;
    font-size: .18rem;
    background: #fff;
    border-radius: 8px;
    margin-bottom: .22rem;
  }
  .wayCon{
    padding-left: 1%;
    padding-bottom: .1rem;
    p{
      background:#F5F5F5;
      color:#333333;
      font-size: .15rem;
      text-align: center;
      display: inline-block;
      width: 31%;
      line-height: .36rem;
      margin:.12rem 1% 0rem;
      position: relative;
      span{
        position: absolute;
        right: 0;
        bottom: 0;
        width: 0;
        height: 0;
        border-width: 0 0 0.20rem 0.28rem ;
        border-color: #1677FF  transparent;
        border-style: solid;
        display: none;
        .success{
          position: relative;
          left:-.15rem;
          top: -3px;
          color: #fff;
        }
      }
      &.check{
        background: #E7F1FF;
        color:#1677FF;
        span{
          display: block;
        }
      }
    }
  }
  
}

</style>